export default __webpack_public_path__ + "static/draw-512e7fd8266e3fcb8751dc5f1d9ff7ba.mp4";